import * as React from "react";

function IconLinkedin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z"
        fill="#fff"
      />
      <path
        d="M10.197 13.973h2.486v7.997h-2.486v-7.997zM11.44 10a1.44 1.44 0 110 2.88 1.44 1.44 0 010-2.88M14.243 13.973h2.38v1.094h.046a2.609 2.609 0 012.35-1.29c2.52 0 2.981 1.655 2.981 3.807v4.386h-2.484v-3.888c0-.927-.015-2.121-1.29-2.121-1.275 0-1.492 1.008-1.492 2.053v3.956h-2.481l-.01-7.997z"
        fill="#0076B2"
      />
    </svg>
  );
}

export default IconLinkedin;
